import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Los datos del ERP no cambian cada segundo; un minuto de frescura evita
      // recargar existencias cada vez que se cambia de pestaña.
      staleTime: 60_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});
